import { EMPTY, Observable } from 'rxjs';
import { expand, map, reduce } from 'rxjs/operators';

export function loopWhileNotEmpty<T>(callback: (page: number) => Observable<T[]>, page = 1): Observable<T[]> {
    return callback(page).pipe(
        expand((results) => {
            return results.length > 0 ? callback(++page) : EMPTY;
        }, 1),
        reduce((concatenedResults: T[], results: T[]) => concatenedResults.concat(results ?? []), []),
        map((results) => (results.filter(result => result !== undefined))),
    );
}
